import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class QuotationService {
    private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/quotation`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    /**
     * Save quotation remarks for a lead
     */
    public saveQuotationRemarks(leadId: number, remarks: string, poFiles?: File[], countryId?: number): Observable<{ message: string; quotation: any }> {
        let url = `${this.URL_PATH}/saveQuotationRemarks/${leadId}`;
        if (countryId) {
            url += `?countryId=${countryId}`;
        }

        const formData = new FormData();
        formData.append('remarks', remarks);
        if (poFiles && poFiles.length > 0) {
            poFiles.forEach((file, index) => {
                formData.append('poFiles', file);
            });
        }

        return this.http
            .post<{ message: string; quotation: any }>(url, formData)
            .pipe(catchError(this.errorHandler.handleError));
    }

    /**
     * Get quotation remarks for a lead
     */
    public getQuotationRemarks(leadId: number): Observable<{ remarks: string }> {
        return this.http
            .get<{ remarks: string }>(`${this.URL_PATH}/getQuotationRemarks/${leadId}`)
            .pipe(catchError(this.errorHandler.handleError));
    }




    /**
     * Get quotation by lead ID
     */
    public getQuotationByLeadId(leadId: number, batchId?: number): Observable<any> {
        let url = `${this.URL_PATH}/getByLeadId/${leadId}`;
        if (batchId) {
            url += `?batchId=${batchId}`;
        }
        return this.http
            .get<any>(url)
            .pipe(catchError(this.errorHandler.handleError));
    }
}

